const React = require("react");
const {openPopupWindow} = require("../../../../../../../emitters/popup");
const Popup = require("../../../../../../dumb/Popup/C");
const FormWithdrawComplete = require("../components/FormWithdrawComplete");

module.exports = (data, update) => {
  openPopupWindow((setPopupState, popup) => {
    const {close} = popup;

    return () => {
      return (
        <Popup
          caption={(
            <div className="layoutRow fhaS fvaC w">
              <div>Complete Withdrawal #{data.id}</div>
            </div>
          )}
        >
          <div className="mt20">If you want to change the status of withdrawal #{data.id} please enter the payout transaction hash.</div>
          <div className="mt40">
            <FormWithdrawComplete
              data={data}
              update={update}
              close={close}
            />
          </div>
        </Popup>
      )
    }
  })
}
